import { EMPTY_GATE_FACTS } from './lifecycle';
import type { ShopGateFacts, ShopOutcome } from './lifecycle';

/** Gate facts the job document itself can answer. Later phases add approvals, parts and verification counts. */
export function gateFactsFromJob(job: {
  customer?: { name?: string | null } | null;
  unit?: { generatorId?: string | null; serial?: string | null; make?: string | null; model?: string | null } | null;
  intake?: { complaint?: string | null } | null;
  outcome?: ShopOutcome | null;
}): ShopGateFacts {
  const u = job.unit;
  return {
    ...EMPTY_GATE_FACTS,
    hasCustomer: !!job.customer?.name,
    hasUnitIdentity: !!(u?.generatorId || u?.serial || (u?.make && u?.model)),
    hasComplaint: !!job.intake?.complaint,
    outcome: job.outcome ?? null,
    // billFullyInvoiced is not derivable from the job doc -- a job's bill and its invoices are
    // separate Phase 3 collections (PRD §11.4). It stays at the EMPTY_GATE_FACTS default (false)
    // until Phase 3 computes it for real and passes it in explicitly.
  };
}
